module.exports = __webpack_public_path__ + "img/tamzirtapoz.cb2b5891.png";